import React from "react";
import { ThemeProvider, theme } from "@reusejs/react";
import { XIcon } from "@heroicons/react/solid";
import Logo from "../../layouts/header/Logo";
import LoginForm from "./LoginForm";

const newTheme = {
  ...theme,
  variants: {},
};

export default function LoginFormModal(props: any) {
  return (
    <ThemeProvider value={newTheme}>
      <div className="relative shadow-sm flex flex-col px-8 py-8 w-full">
        <div className="flex-1">
          <div className="absolute z-50 -top-4 -right-4 rounded-full bg-gray-50 items-center px-2 py-2 border-b text-xs text-gray-900">
            <div
              className="cursor-pointer"
              onClick={() => props.onAction("no")}
            >
              <XIcon className="h-4 w-4" aria-hidden="true" />
            </div>
          </div>
          <div className="flex justify-center">
            <Logo />
          </div>
          <div className="flex flex-col justify-center items-center mt-4">
            <div className="justify-center border-t-2 border-blue-200 w-28"></div>

            <h2 className="mt-4 text-2xl font-semibold text-gray-800 tracking-tight">
              Welcome back
            </h2>
            <p className="mt-3 text-base text-gray-600">
              <span className="text-gray-400">Please enter your details.</span>
            </p>
          </div>
          <LoginForm {...props} />
        </div>
      </div>
    </ThemeProvider>
  );
}
